import { render, staticRenderFns } from "./import-data.vue?vue&type=template&id=fddbd702&scoped=true"
import script from "./import-data.vue?vue&type=script&lang=js"
export * from "./import-data.vue?vue&type=script&lang=js"
import style0 from "./import-data.vue?vue&type=style&index=0&id=fddbd702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddbd702",
  null
  
)

export default component.exports